// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Sp-z","articleImagesWrap":"Tp-z","articleImage":"Up-z","singleImage":"Vp-z"};